import React from 'react';
import { Add16Regular } from '@fluentui/react-icons';
import styles from '../css/vdr.module.css';
import { SearchField, StatusDot, StatusFilters, normalizeStatus } from '../components/StatusUI';
const TranscriptStatus = ({ status }) => {
    const isReady = status === 'ready';
    return (
        <span className={isReady ? styles.transcriptStatusReady : styles.transcriptStatusMuted}>
            {isReady ? 'Ready' : 'None'}
        </span>
    );
};

const MeetingRecordingsView = ({
    recordings = [],
    onSelect,
    selectedId,
    onUpload,
}) => {
    const [search, setSearch] = React.useState('');
    const [filter, setFilter] = React.useState('all');

    const filtered = recordings.filter(r => {
        const status = normalizeStatus(r.status);
        if (filter !== 'all' && status !== filter) return false;
        if (!search.trim()) return true;
        const q = search.trim().toLowerCase();
        return (
            r.title?.toLowerCase().includes(q) ||
            r.source?.toLowerCase().includes(q) ||
            (r.participantNames || []).some(n => n.toLowerCase().includes(q))
        );
    });

    return (
        <>
            <div className={styles.contentHeader}>
                <div>
                    <h2 className={styles.contentTitle}>Meeting Recordings</h2>
                    <p className={styles.contentDesc}>
                        Meeting recordings, transcripts and related metadata available as project evidence.
                    </p>
                </div>
                <button type="button" className={styles.primaryBtn} onClick={() => onUpload?.()}>
                    <Add16Regular /> Upload recording
                </button>
            </div>

            <div className={styles.toolbar}>
                <SearchField value={search} onChange={setSearch} placeholder="Search recordings" />
                <StatusFilters value={filter} onChange={setFilter} />
            </div>

            {filtered.length === 0 ? (
                <div className={styles.emptyState}>No recordings match your filters.</div>
            ) : (
                <div className={styles.table}>
                    <div className={`${styles.tableHead} ${styles.recordingCols}`}>
                        <span>Recording</span>
                        <span>Meeting date</span>
                        <span>Duration</span>
                        <span>Source</span>
                        <span>Transcript</span>
                        <span>Lens status</span>
                    </div>
                    {filtered.map(rec => (
                        <div
                            key={rec.id}
                            className={`${styles.tableRow} ${styles.recordingCols} ${
                                selectedId === rec.id ? styles.tableRowSelected : ''
                            }`}
                            onClick={() => onSelect?.(rec)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') onSelect?.(rec);
                            }}
                        >
                            <div>
                                <div className={styles.tableRowName}>
                                    <span>{rec.title}</span>
                                </div>
                                <div className={styles.subMeta}>{rec.participants || 0} participants</div>
                            </div>
                            <span className={styles.cellMuted}>{rec.meetingDate}</span>
                            <span className={styles.cellMuted}>{rec.duration}</span>
                            <span>
                                <span className={styles.sourcePill}>{rec.source}</span>
                            </span>
                            <TranscriptStatus status={rec.transcriptStatus} />
                            <StatusDot status={rec.status} />
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default MeetingRecordingsView;
